import { Component, input } from '@angular/core';
import { TextDirective } from '../../../typography/text.directive';
import { NgpPaginationButton } from 'ng-primitives/pagination';

@Component({
  selector: 'button[joii-pagination-number]',
  imports: [TextDirective],
  hostDirectives: [
    {
      directive: NgpPaginationButton,
      inputs: ['ngpPaginationButtonPage:page'],
    },
  ],
  template: `<span joii-text [size]="4">{{ page() }}</span>`,
  styles: `
    :host {
      width: 24px;
      height: 24px;
    }
    :host span[joii-text] {
      color: var(--Vetai-Form_controls--Border_Default);
    }
    :host span[joii-text]:hover {
      color: var(--Vetai-Form_controls--Border_Hover);
    }
    :host[data-selected] span[joii-text] {
      color: var(--Vetai-Inline_links_and_info--Default);
      font-weight: var(--Vetai-Font-Weight-Semibold);
    }
  `,
})
export class PaginationNumberComponent {
  /** Page number passed from the host and forwarded to NgpPaginationButton. */
  readonly page = input.required<number>();
}
